<template>
  <div
    :class="[
      $route.meta.headerType === 'index'
        ? 'c-index-header-wrapper'
        : 'c-header-wrapper',
      $route.meta.headerType === 'other'
        ? 'c-header-wrapper'
        : 'c-index-header-wrapper'
    ]"
  >
    <div class="c-header-info">
      <img
        v-if="activeIndex === '/'"
        src="../../../assets/Logo-2.png"
        class="logo"
      />
      <img v-else src="../../../assets/Logo.png" class="logo" />
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        router
      >
        <el-menu-item index="/">{{ $t("nav.home") }}</el-menu-item>

        <el-menu-item index="/product">
          <div class="tips" v-if="showTips">
            <div style="flex: 1;">
              {{ $t("nav.tips") }}
            </div>
            <i
              class="el-icon-error"
              style="color:#144FA1;"
              @click.stop="showTips = false"
            ></i>
          </div>
          {{ $t("nav.product") }}
        </el-menu-item>

        <!-- <el-submenu index="/product" popper-class="my-sub-menu">
          <template slot="title">{{ $t("nav.product") }}</template>

          <div v-for="pItem in productCategory" :key="pItem.ID">
            <el-submenu
              v-if="pItem.Childs && pItem.Childs.length > 0"
              :index="`/product?id=${pItem.ID}`"
            >
              <template slot="title">{{
                productCategoryItemName(pItem)
              }}</template>

              <el-menu-item
                v-for="cItem in pItem.Childs"
                :key="cItem.ID"
                :index="`/product?id=${cItem.ID}`"
                :route="{
                  path: '/product',
                  query: { id: cItem.ID }
                }"
                >{{ productCategoryItemName(cItem) }}</el-menu-item
              >
            </el-submenu>

            <el-menu-item
              v-else
              :index="`/product?id=${pItem.ID}`"
              :route="{ path: '/product', query: { id: pItem.ID } }"
              >{{ productCategoryItemName(pItem) }}</el-menu-item
            >
          </div>
        </el-submenu> -->

        <el-menu-item index="/news">{{ $t("nav.news") }}</el-menu-item>
        <el-menu-item index="/about-us">{{ $t("nav.aboutUs") }}</el-menu-item>
        <el-menu-item index="/contact-us">{{
          $t("nav.contactUs")
        }}</el-menu-item>
      </el-menu>
      <div class="header-right">
        <el-dropdown trigger="click" :hide-on-click="false">
          <span class="el-dropdown-link">
            <i class="iconfont icon-sousuo"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="search-dropdown">
            <!-- <el-dropdown-item> -->
            <div class="dropdown-item">
              <el-input
                :placeholder="$t('other.keyWords')"
                v-model="searchVal"
                :clearable="true"
                @clear="onClear"
              >
                <el-button slot="append" @click="search">{{
                  $t("other.search")
                }}</el-button>
              </el-input>
            </div>
            <!-- </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="iconfont icon-diqiu"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="language-dropdown">
            <el-dropdown-item @click.native="setLang('zh')">{{
              $t("lang.zh")
            }}</el-dropdown-item>
            <el-dropdown-item @click.native="setLang('en')">{{
              $t("lang.en")
            }}</el-dropdown-item>
            <el-dropdown-item @click.native="setLang('sp')">{{
              $t("lang.sp")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      searchVal: "",
      productCategory: [],
      showTips: true
    };
  },
  computed: {
    activeIndex() {
      return this.$route.fullPath;
    }
  },
  mounted() {
    const params = {
      Data: {
        ItemParentID: 2
      }
    };
    this.$store
      .dispatch("getProductCategoryData", params)
      .then(res => {
        this.productCategory = res;
      })
      .catch(res => {
        this.$message({
          message: res,
          type: "warning"
        });
      });
  },
  methods: {
    handleSelect() {
      // console.log(key, keyPath);
    },
    search() {
      this.$router.push({
        path: "/product",
        query: {
          searchVal: this.searchVal
        }
      });
    },
    onClear() {
      this.$router.push({
        query: {}
      });
      this.reload();
    },
    // 后端返回了全部国家的语言，用这个方法设置产品分类显示哪国语言
    productCategoryItemName(item) {
      let name = null;
      if (this.$i18n.locale === "zh") {
        name = item.ItemName;
      } else if (this.$i18n.locale === "en") {
        name = item.EnglishName;
      } else if (this.$i18n.locale === "sp") {
        name = item.xibanyaName;
      }
      return name;
    },
    // 设置语言
    setLang(lang) {
      this.$i18n.locale = lang;
      this.reload();
    }
  },
  watch: {
    searchVal(val) {
      if (!val) {
        this.$router.push({
          query: {}
        });
        this.reload();
      }
    }
  }
};
</script>

<style lang="less">
@import url("./less/IndexHeader.less");
@import url("./less/Header.less");
.search-dropdown {
  .dropdown-item {
    width: 1200px;
    height: 120px;
    padding: 20px 80px;
    .el-input {
      width: 100%;
      height: 100%;

      input {
        width: 100%;
        height: 100%;
        border-top: none;
        border-left: none;
        border-right: none;
        border-color: #dcdcdc;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .el-input-group__append {
      background: #fff;
      border-top: none;
      border-left: none;
      border-right: none;
      border-color: #dcdcdc;
      button {
        width: 120px;
        height: 38px;
        line-height: 38px;
        padding: 0;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(85, 85, 85, 1);
        border-radius: 2px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(85, 85, 85, 1);
      }
    }
  }
}
.language-dropdown {
  background: linear-gradient(
    90deg,
    rgba(18, 86, 167, 1) 0%,
    rgba(20, 80, 162, 1) 100%
  );
  border: none;
  li {
    color: #fff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  .popper__arrow {
    display: none;
  }
}
</style>
